import { AvatarProps, Stack, Typography, TypographyProps } from '@mui/material';
import { mapNetworkToFullName } from '@razz-team/utils';
import { AvatarNetwork } from '../Avatar/AvatarNetwork';

export interface NetworkProps extends TypographyProps {
  network: string;
  withAvatar?: boolean;
  avatarSize?: AvatarProps['size'];
}

export function Network({ network, withAvatar, avatarSize, ...props }: NetworkProps) {
  const typography = <Typography {...props}>{mapNetworkToFullName(network)}</Typography>;

  if (!withAvatar) return typography;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <AvatarNetwork network={network} size={avatarSize} />
      {typography}
    </Stack>
  );
}
